// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"11351": "508486e30cd3","18357": "70fb16f8c80d","6557": "233a26aa12cc","66863": "c939bdd77392","70004": "c40dab97fa29","8312": "6e62f07ea8f1","90912": "a4a5593b6ed1",}[chunkId] + ".css"
}